module.exports = __webpack_public_path__ + "img/logo.f010f41a.png";